import React, { createContext, useContext, useState, useEffect } from 'react';

const LocaleContext = createContext();

export function LocaleProvider({ children }) {
    const [locale, setLocaleState] = useState(() => {
        return localStorage.getItem("locale") || 'en';
    });

    const setLocale = (newLocale) => {
        localStorage.setItem("locale", newLocale);
        setLocaleState(newLocale);
    };

    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'locale' && e.newValue) {
                setLocaleState(e.newValue);
            }
        };
        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    return (
        <LocaleContext.Provider value={{ locale, setLocale }}>
            {children}
        </LocaleContext.Provider>
    );
}

export function useLocale() {
    const context = useContext(LocaleContext);
    if (!context) {
        throw new Error('useLocale must be used within a LocaleProvider');
    }
    return context;
}
